module.exports = __webpack_public_path__ + "media/src/images/partners/usi-8c31affd97cc637ceb3c5b0bf01cbc86.jpg";